<p-toast *ngIf="!commonService.isMobileView" position="top-right"></p-toast>
<p-toast position= "top-right" [breakpoints]="{'991px': {width: '100%', right: '0', left: '0'}}" *ngIf="commonService.isMobileView"></p-toast>
<p-dialog header="Success!" [(visible)]="displayBasic" [style]="{width: '50vw'}" [baseZIndex]="10000">
  <p>Password Update Successful! You can login to your Portal with the new Password </p>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="goToLogin();" label="Ok, Go to Login" styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>
<div class="row w-100 mx-0 auth-page">
  <div class="col-md-8 col-xl-4 mx-auto">
    <div class="card cus-card">
      <div class="row">
        <div class="col-md-12 pl-md-2 pr-md-2">
          <div class="auth-form-wrapper px-4 py-4 ">
            <!-- <a routerLink="." class="noble-ui-logo d-block mb-2 text-center"><img
                              src="assets/images/iPOSpays.svg" alt="IPOSPAYS LOGO" width="150" /></a> -->
            <h5 class="font-weight-normal mb-4 text-center">Password Reset</h5>
            <form class="forms-sample" [formGroup]="resetForm" (submit)="onFormSubmit()">
              <div class="form-group">
                <label for="exampleInputEmail1">Password</label>
                <div class="position-relative">
                  <input [type]="showHidePassword ? 'text' : 'password'"
                    ngbPopover="Password must have  at least 12 characters that include at least 1 lowercase character, 1 uppercase character, 1 number, and 1 special character in (!@#$%^&*)"
                    placement="right" class="form-control" formControlName="password" placeholder="Password" required>
                  <span (click)="showpassword()"><i class="mdi position-absolute"
                      [ngClass]="{'mdi-eye-off-outline':!showHidePassword, 'mdi-eye-outline':showHidePassword}"></i>
                  </span>
                </div>
                <div
                  *ngIf="!resetForm.get('password').valid && (resetForm.get('password').dirty || resetForm.get('password').touched)">
                  <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="getPasswordErrorMessage()">
                    {{ getPasswordErrorMessage() }}
                  </ngb-alert>    
                </div>
              </div>
              <div class="form-group">
                <label for="exampleInputEmail1">Confirm Password</label>
                <div class="position-relative">
                  <input [type]="showHideConfirmPassword ? 'text' : 'password'" class="form-control" formControlName="cpassword"
                    placeholder="Confirm Password" required>
                  <span (click)="showconfirmpassword()"><i class="mdi position-absolute"
                      [ngClass]="{'mdi-eye-off-outline':!showHideConfirmPassword, 'mdi-eye-outline':showHideConfirmPassword}"></i>
                  </span>
                </div>
                <div
                  *ngIf="!resetForm.get('cpassword').valid && (resetForm.get('cpassword').dirty || resetForm.get('cpassword').touched)">
                  <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="resetForm.get('cpassword').errors.required">
                    {{'errorMsg.missingCPassword' | translate}}
                  </ngb-alert>
                  <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="resetForm.get('cpassword').errors.NoPassswordMatch">
                    Password does not match
                  </ngb-alert>
                </div>
              </div>
              <div class="mt-3">
                <button type="submit" class="btn btn-submit mr-2 mb-2 mb-md-1 btn-block" [disabled]="isLoading">
                  <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span><span class="loader_ml">Update Password</span></button>
              </div>
            </form>
            <a routerLink="." *ngIf="!loginLogo" class="noble-ui-logo d-block text-center mt-3"><img src="{{defaultURL}}"
                alt="IPOSPAYS LOGO" width="150" /></a>
                <a routerLink="." *ngIf="loginLogo" class="noble-ui-logo d-block text-center"><img class="logo_align left-logo" src="{{loginLogo}}"
                  alt="IPOSPAYS" width="150" height="auto"/></a>
               <p  *ngIf="!loginLogo" class="text-center font-weight-normal logo-tag-line">It's <span>more</span> than a transaction!</p>
               <p *ngIf="tagName" class="text-center font-weight-normal logo-tag-line">{{tagName}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
